import { useState, useRef } from "react";

import { QRCodeCanvas }
from "qrcode.react";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";

export default function QRGenerator() {

  const [text, setText] =
    useState("");

  const [size, setSize] =
    useState(220);

  const [fgColor, setFgColor] =
    useState("#000000");

  const [bgColor, setBgColor] =
    useState("#ffffff");

  const [copied, setCopied] =
    useState(false);

  const qrRef =
    useRef(null);

  /* DOWNLOAD */

  const downloadQR = () => {

    const canvas =
      qrRef.current.querySelector("canvas");

    const url =
      canvas.toDataURL("image/png");

    const link =
      document.createElement("a");

    link.href = url;

    link.download =
      "qr-code.png";

    link.click();
  };

  /* COPY */

  const copyText = () => {

    navigator.clipboard.writeText(
      text
    );

    setCopied(true);

    setTimeout(() => {

      setCopied(false);

    }, 2000);
  };

  return (
    <>
      <SEO
        title="Free QR Code Generator Online"
        description="Generate QR codes instantly online for URLs, text, WiFi, and links with download support."
        keywords="QR generator, free QR code generator, QR maker, QR code online"
        url="https://online-tools-center.vercel.app/qr-generator"
      />

      <Navbar />

      <div className="container py-4">

        <div className="row justify-content-center">

          <div className="col-lg-10">

            <div className="card shadow-lg border-0 rounded-4 p-4">

              {/* HERO */}

              <div className="text-center mb-5">

                <h1 className="fw-bold mb-3">
                  QR Code Generator
                </h1>

                <p className="text-muted">
                  Generate QR codes instantly
                  for URLs, text, contact
                  details, and more.
                </p>

                <div className="d-flex flex-wrap justify-content-center gap-2 mt-3">

                  <span className="badge bg-light text-dark p-2">
                    ✓ Instant QR Preview
                  </span>

                  <span className="badge bg-light text-dark p-2">
                    ✓ Download PNG
                  </span>

                  <span className="badge bg-light text-dark p-2">
                    ✓ Color Customization
                  </span>

                  <span className="badge bg-light text-dark p-2">
                    ✓ Free Tool
                  </span>

                </div>

              </div>

              {/* MAIN */}

              <div className="row g-4">

                {/* LEFT */}

                <div className="col-md-6">

                  <label className="fw-semibold mb-2">
                    Enter Text or URL
                  </label>

                  <textarea
                    className="form-control mb-4"
                    rows="5"
                    placeholder="Enter URL, text, phone number, or any content"
                    value={text}
                    onChange={(e) =>
                      setText(
                        e.target.value
                      )
                    }
                  />

                  {/* SIZE */}

                  <label className="fw-semibold mb-2">
                    QR Size:
                    {" "}
                    {size}px
                  </label>

                  <input
                    type="range"
                    min="150"
                    max="400"
                    value={size}
                    className="form-range mb-4"
                    onChange={(e) =>
                      setSize(
                        e.target.value
                      )
                    }
                  />

                  {/* COLORS */}

                  <div className="row">

                    <div className="col-6">

                      <label className="fw-semibold mb-2">
                        Foreground
                      </label>

                      <input
                        type="color"
                        className="form-control form-control-color w-100"
                        value={fgColor}
                        onChange={(e) =>
                          setFgColor(
                            e.target.value
                          )
                        }
                      />

                    </div>

                    <div className="col-6">

                      <label className="fw-semibold mb-2">
                        Background
                      </label>

                      <input
                        type="color"
                        className="form-control form-control-color w-100"
                        value={bgColor}
                        onChange={(e) =>
                          setBgColor(
                            e.target.value
                          )
                        }
                      />

                    </div>

                  </div>

                </div>

                {/* RIGHT */}

                <div className="col-md-6">

                  <div className="bg-light rounded-4 p-4 text-center h-100 d-flex flex-column justify-content-center">

                    <h4 className="fw-bold mb-4">
                      Live QR Preview
                    </h4>

                    {text ? (

                      <>

                        <div
                          ref={qrRef}
                          className="mb-4"
                        >

                          <QRCodeCanvas
                            value={text}
                            size={size}
                            fgColor={fgColor}
                            bgColor={bgColor}
                          />

                        </div>

                        <div className="d-flex flex-wrap justify-content-center gap-3">

                          <button
                            className="btn btn-primary"
                            onClick={downloadQR}
                          >
                            Download PNG
                          </button>

                          <button
                            className="btn btn-dark"
                            onClick={copyText}
                          >
                            {copied
                              ? "Copied!"
                              : "Copy Text"}
                          </button>

                        </div>

                      </>

                    ) : (

                      <p className="text-muted">
                        Enter text or URL
                        to generate QR code.
                      </p>

                    )}

                  </div>

                </div>

              </div>

            </div>

           {/* SEO SECTION */}
<div className="mt-5">

  <h2 className="fw-bold mb-3">What is a QR Code?</h2>
  <p>
    A QR code (Quick Response code) is a two-dimensional barcode that can store
    text, URLs, phone numbers, email addresses, and other data in a
    machine-readable format. When scanned with a smartphone camera or QR
    scanner app, the code instantly opens the stored link or displays the
    stored information — no typing required. QR codes were originally developed
    in 1994 by a Japanese company for tracking automotive parts, but today they
    are used everywhere from restaurant menus and business cards to payment
    systems and product packaging. Their ability to store large amounts of
    data in a compact square image makes them one of the most versatile tools
    in digital communication.
  </p>

  <h2 className="fw-bold mt-5 mb-3">How to Use This QR Code Generator</h2>
  <ol>
    <li className="mb-2">
      <strong>Enter your content</strong> in the text box — this can be a
      website URL, a plain text message, a phone number, an email address,
      a WhatsApp link, a UPI payment link, or any other text you want to
      encode.
    </li>
    <li className="mb-2">
      <strong>Adjust the QR size</strong> using the slider. A larger size
      is better for printing on banners or posters, while a smaller size
      works fine for business cards and digital sharing.
    </li>
    <li className="mb-2">
      <strong>Customize colors</strong> — change the foreground color
      (the dark squares) and background color to match your brand or
      design preference. Make sure there is enough contrast between the
      two colors so the QR code remains scannable.
    </li>
    <li className="mb-2">
      <strong>Preview your QR code</strong> live on the right side of
      the screen. The preview updates instantly as you type or change settings.
    </li>
    <li className="mb-2">
      <strong>Download as PNG</strong> — click the Download button to save
      your QR code as a high-quality PNG image file ready to use anywhere.
    </li>
  </ol>

  <h2 className="fw-bold mt-5 mb-3">What Can You Use QR Codes For?</h2>
  <p>
    QR codes have hundreds of practical uses in both personal and business
    contexts. Businesses use them to link customers to websites, product pages,
    Google reviews, or social media profiles without requiring manual URL entry.
    Restaurants use QR codes on tables to display digital menus. Event organizers
    use them for contactless ticketing and check-in. Teachers and educators use
    QR codes in worksheets and classroom materials to link students to videos,
    resources, or assignment submission pages. Freelancers and professionals
    add QR codes to business cards linking to their portfolio or LinkedIn profile.
    In India, QR codes are widely used for UPI payments — simply encoding your
    UPI ID or payment link into a QR code allows anyone to pay you by scanning
    with their phone. Our generator supports all of these use cases.
  </p>

  <h2 className="fw-bold mt-5 mb-3">Tips for Creating Better QR Codes</h2>
  <p>
    For best scanning results, always maintain strong contrast between the
    foreground and background colors. Black on white is the most reliable
    combination, but dark colors on light backgrounds generally work well.
    Avoid using light colors on dark backgrounds or similar shades that reduce
    contrast, as these can cause scanning failures on older devices. When
    printing QR codes, use a minimum size of 2.5 cm × 2.5 cm to ensure
    they can be scanned from a normal distance. Test your QR code by scanning
    it with your own phone before distributing it widely. For URLs, consider
    using a short URL (from a URL shortener) before encoding it, as shorter
    content produces a simpler QR code that scans more reliably.
  </p>

  <h2 className="fw-bold mt-5 mb-3">Frequently Asked Questions</h2>

  <div className="mb-4">
    <h5>Is this QR code generator free?</h5>
    <p>
      Yes, our QR code generator is completely free to use with no limits on
      the number of QR codes you can create. There is no account required,
      no watermark added to downloaded images, and no expiry on the QR codes
      you generate.
    </p>
  </div>

  <div className="mb-4">
    <h5>Do the QR codes expire?</h5>
    <p>
      No. QR codes generated by our tool do not expire because they encode
      data directly into the image itself — there is no server or database
      involved. As long as the URL or content you encoded remains valid,
      your QR code will continue to work indefinitely. If you encoded a
      website URL and that website goes offline, the QR code will still
      scan correctly but the destination will be unavailable.
    </p>
  </div>

  <div className="mb-4">
    <h5>Can I use QR codes for WhatsApp or UPI payments?</h5>
    <p>
      Yes. To create a WhatsApp QR code, enter a link in the format
      https://wa.me/91XXXXXXXXXX (replacing X with the phone number including
      country code). For UPI payments, enter your UPI payment link or UPI ID
      in the text box and generate a QR code that anyone can scan to pay you
      directly through any UPI app like Google Pay, PhonePe, or Paytm.
    </p>
  </div>

  <div className="mb-4">
    <h5>What format is the downloaded QR code?</h5>
    <p>
      The QR code is downloaded as a PNG image file, which is a lossless
      format suitable for both digital use and printing. PNG files maintain
      sharp edges and clean lines, making them ideal for QR codes which
      require precise patterns to scan correctly. You can use the downloaded
      PNG in documents, presentations, websites, or send it via email or
      messaging apps.
    </p>
  </div>

  <div className="mb-4">
    <h5>Can I change the color of my QR code?</h5>
    <p>
      Yes. Our generator lets you customize both the foreground color (the
      dark pattern) and the background color. This is useful when you want
      to match a QR code to your brand colors. Always ensure the foreground
      is significantly darker than the background to maintain scannability.
      Avoid inverting colors (light pattern on dark background) as many
      older QR scanners cannot read inverted codes.
    </p>
  </div>

  {/* RELATED TOOLS */}
  <div className="mt-5 p-4 bg-light rounded-4">
    <h3 className="fw-bold mb-3">Related Tools</h3>
    <div className="d-flex flex-wrap gap-3">
      <a href="/password-generator" className="btn btn-outline-primary">Password Generator</a>
      <a href="/json-formatter" className="btn btn-outline-primary">JSON Formatter</a>
      <a href="/percentage-calculator" className="btn btn-outline-primary">Percentage Calculator</a>
    </div>
  </div>

</div>
          </div>

        </div>

      </div>

      <Footer />

    </>
  );
}